import { ContentStackStoreType } from './types'

import { createReactStore } from '@/utils/create-react-store'

export const ContentStackStore = createReactStore<ContentStackStoreType>(
  () => ({
    entries: new Map(),
    contentStackClient: undefined,
  }),
)
